import React, { useState } from 'react'
import Layout from '../../Layout'
import { Rating } from 'react-simple-star-rating'
import HeaderMain from '../../Components/HeaderMain'
import { useScore } from '../../Hook/App'
import Spinner from '../../Components/Spinner'
function Index() {
    const { addRate, form, room, onChange, loading, send } = useScore();
    return (
        <Layout>
            <HeaderMain lable="امتیازدهی" />
            <div className="score-main">
                <div className="d-flex justify-content-center">
                    <div className="img">
                        <img src={require("../../assets/image/peoduct.jpg")} alt="no image" />
                    </div>
                </div>
                <p>{room && room.item && room.item.user && room.item.user.name}</p>
                <p className="light">{room && room.item && room.item.name}</p>
                <p className="mini">به کیفیت خدمات رسانی این آگهی دهنده چه امتیازی می دهید؟</p>
                <div className='App'>
                    <Rating
                        onClick={(val) => addRate('score', val)}
                        ratingValue={form.score}
                        size={35}
                        label
                        transition
                        fillColor='orange'
                        emptyColor='gray'
                        className='foo'
                    />
                </div>
                <span className="mini">{(form.score / 20)} از 5</span>
                {form.score ? <>
                    <div>
                        <div className="d-flex justify-content-between mt-5">
                            <span className="mini">سرعت پاسخگویی</span>
                            <Rating
                                onClick={(val) => addRate('speed', val)}
                                ratingValue={form.speed}
                                size={25}
                                label
                                transition
                                fillColor='orange'
                                emptyColor='gray'
                                className='foo'
                            />
                        </div>
                        <div className="d-flex justify-content-between mt-3">
                            <span className="mini">نحوه برخورد با مشتری</span>
                            <Rating
                                onClick={(val) => addRate('feedback', val)}
                                ratingValue={form.feedback}
                                size={25}
                                label
                                transition
                                fillColor='orange'
                                emptyColor='gray'
                                className='foo'
                            />
                        </div>
                        <div className="d-flex justify-content-between mt-3">
                            <span className="mini">صحت اطلاعات مشتری</span>
                            <Rating
                                onClick={(val) => addRate('verify', val)}
                                ratingValue={form.verify}
                                size={25}
                                label
                                transition
                                fillColor='orange'
                                emptyColor='gray'
                                className='foo'
                            />
                        </div>
                        <textarea onChange={onChange} placeholder="نظر خود را درباره ی این آگهی دهنده بنویسید" name="comment" rows="4"></textarea>
                    </div>
                    <button className="btn" onClick={send} disabled={loading} style={{ backgroundColor: "#7367f0" }}>{loading ? <Spinner sm /> : "ثبت امتیاز"}</button>
                </>
                    : null}
            </div>
        </Layout>
    )
}

export default Index